import _styled from "styled-components";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Box from "../../../Styled/Box";
import Text from "../../../Styled/Text";
import { CollapseBtn, ExitBtn } from "./StoryButtons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TitleContainer = styled(Box).attrs({
  fullWidth: true,
  flex: 1,
  verticalCenter: true
}).withConfig({
  displayName: "TitleBar__TitleContainer",
  componentId: "sc-1d4bpxh-0"
})([""]);
const ClampedTitle = styled(Text).attrs({
  as: "h3"
}).withConfig({
  displayName: "TitleBar__ClampedTitle",
  componentId: "sc-1d4bpxh-1"
})(["white-space:nowrap;text-overflow:ellipsis;font-weight:500;overflow:hidden;padding:0;margin:0;@supports (-webkit-line-clamp:2){display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:unset;}"]);
const TitleBar = _ref => {
  let {
    title,
    isCollapsed,
    collapseHandler,
    closeHandler
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(_StyledBox, {
    fullWidth: true,
    gap: 4,
    paddedRatio: 0,
    paddedVertically: 2,
    children: [/*#__PURE__*/_jsx(TitleContainer, {
      children: /*#__PURE__*/_jsx(ClampedTitle, {
        children: title ? title : t("story.untitled")
      })
    }), /*#__PURE__*/_jsx(CollapseBtn, {
      isCollapsed: isCollapsed,
      onClick: collapseHandler
    }), /*#__PURE__*/_jsx(ExitBtn, {
      onClick: closeHandler
    })]
  });
};
export default TitleBar;
var _StyledBox = styled(Box).withConfig({
  displayName: "TitleBar___StyledBox",
  componentId: "sc-1d4bpxh-2"
})(["padding-top:0;"]);